
var Ably = require('ably');
var configurationManager = require('../../config/configurationManager.js');
var terminalUtility = require('../../domain/terminalUtility.js');
var commonUtility = require('../../domain/commonUtility.js');
const logger = require('../../logger/logger.js');
const stringUtil = require('../../string/stringUtil.js');
var guidUtil = require('../../guid/guidUtil.js');
var jobsServer = require('../../jobs/jobsServer.js');

var messagingClient;
var messagingChannel;

export function getChannelName (property)
{
    return `property.${property.id}.notification`;
}


export function establishRestApiConnection ()
{
    if (messagingChannel != null)
        return;

    var connectionOptions = {};
    connectionOptions.key = configurationManager.getConfig().messagingPlatformApiKey;
    connectionOptions.clientId = terminalUtility.getTerminalCode();
    messagingClient = new Ably.Rest(connectionOptions);

    messagingChannel = messagingClient.channels.get(getChannelName(commonUtility.getProperty()));
}

export function publishMessage (message)
{
    if (stringUtil.isStringNullOrEmpty(message.id))
        message.id = guidUtil.generateGuid();

    var payload = {};
    payload.name = `${message.type}.${message.notificationType}`;
    payload.data = JSON.stringify(message);

    jobsServer.addJob(message.id, 'Publishing.Message.Notification.Channel',
                        async ()=>
                        {
                            await new Promise ((resolve, reject) =>
                            {
                                try
                                {
                                    establishRestApiConnection();
                                    messagingChannel.publish(payload, (error) =>
                                    {
                                        if(error)
                                        {
                                            let errorMessage = `Error reported in callback when publishing message to notification channel. ${error}`;
                                            reject(errorMessage);
                                            return;
                                        }

                                        resolve(true);
                                    });
                                }
                                catch(error)
                                {
                                    reject(error);
                                }
                            })
                        }, false, null, null, 20);
}